'use client';

import { useEffect, useState } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import { ArrowUpIcon } from '@/components/ui/icons/ArrowUp';
import { StyledScrollToTopButton } from '@/components/ui/scroll/ScrollToTopButton.styles';
import { useReducedMotion, scrollBehavior } from '@/utils/useReducedMotion';

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isMobile || !visible) return null;

  return (
    <StyledScrollToTopButton
      aria-label='Scroll to top'
      onClick={() => window.scrollTo({ top: 0, behavior: scrollBehavior(reducedMotion) })}
    >
      <ArrowUpIcon size={16} />
    </StyledScrollToTopButton>
  );
}
